howspace.widgets.onEvent('discussion:demo-content-creation:completed', (widget, notification) => {
    howspace.aiGen.clearPromptTimeout(widget);
});
